import Vue       from 'vue';
import App       from './App.vue';
import router    from './router';
import store     from './store';
import axios     from 'axios';
import mixins    from './mixins.js';
import Vuelidate from 'vuelidate';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import  vSelect from 'vue-select'
import {
  BasicDropdown,
  BasicTextInput,
  Checkbox,
  CurrencyInput,
  Datepicker,
  PercentInput,
  PhoneNumberInput,
  SelectInput,
  StateSelect,
  TextAreaInput,
  TextInputWithRightHeader,
  ToggleSwitch,
  ZipCodeInput,
  RoleSelect,
  ManagerSelect,
  SalesRepSelect,
  ColleagueSelect,
  FileInput,
  Modal,
} from '@/components'

Vue.config.productionTip = false;

let componentsArray = [
  BasicDropdown,
  BasicTextInput,
  Checkbox,
  CurrencyInput,
  Datepicker,
  PercentInput,
  PhoneNumberInput,
  SelectInput,
  StateSelect,
  TextAreaInput,
  TextInputWithRightHeader,
  ToggleSwitch,
  ZipCodeInput,
  RoleSelect,
  ManagerSelect,
  SalesRepSelect,
  ColleagueSelect,
  FileInput,
  Modal,
]
// Globally Registering these base components so we don't have to import them into every view/component
// Just make sure you reference them as.. ex: <BasicDropdown />  or  <basic-dropdown />
componentsArray.forEach(c => {
  //looping through every component
  Vue.component(`${c.name}`, c);
})

// Vue.component('BasicDropdown',            () => import('@/components'));
// Vue.component('BasicTextInput',           BasicTextInput);
// Vue.component('Checkbox',                 () => import('@/components/inputComponents/Checkbox.vue'));
// Vue.component('CurrencyInput',            () => import('@/components/inputComponents/CurrencyInput.vue'));
// Vue.component('Datepicker',               () => import('@/components/inputComponents/DatepickerCustom.vue'));
// Vue.component('PercentInput',             () => import('@/components/inputComponents/PercentInput.vue'));
// Vue.component('PhoneNumberInput',         () => import('@/components/inputComponents/PhoneNumberInput.vue'));
// Vue.component('SelectInput',              () => import('@/components/inputComponents/SelectInput.vue'));
// Vue.component('StateSelect',              () => import('@/components/inputComponents/StateSelect.vue'));
// Vue.component('TextAreaInput',            () => import('@/components/inputComponents/TextAreaInput.vue'));
// Vue.component('TextInputWithRightHeader', () => import('@/components/inputComponents/TextInputWithRightHeader.vue'));
// Vue.component('ToggleSwitch',             () => import('@/components/inputComponents/ToggleSwitch.vue'));
// Vue.component('ZipCodeInput',             () => import('@/components/inputComponents/ZipCodeInput.vue'));
// Vue.component('RoleSelect',               () => import('@/components/inputComponents/RoleSelect.vue'));
// Vue.component('ManagerSelect',            () => import('@/components/inputComponents/ManagerSelect.vue'));
// Vue.component('SalesRepSelect',           () => import('@/components/inputComponents/SalesRepSelect.vue'));
// Vue.component('ColleagueSelect',          () => import('@/components/inputComponents/ColleagueSelect.vue'));
// Vue.component('FileInput',                () => import('@/components/inputComponents/FileInput.vue'));

// Vue.component('Modal',                    () => import('@/components/Modal.vue'));

Vue.component('v-select', vSelect);

Vue.use(Vuelidate);

new Vue({
  router,
  store,
  mixins: mixins,
  render: h => h(App)
}).$mount('#app');

axios.interceptors.request.use(config => {
  if(!config.isDataSourceRequest) 
  {
    store.commit('ADD_REQUEST');
  }
  return config;
},  (err) => {
  console.log('err', err)
  if(!err.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  return Promise.reject(err);
});

axios.interceptors.response.use(response => {
  if(!response.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  return response;
},(err) => {
  if(!err.config.isDataSourceRequest) store.commit('REMOVE_REQUEST');
  if (err.response.status === 403 || err.response.status === 401 ) {
    if(err.response.status === 403){
      store.dispatch('ADD_NOTIFICATION', { text: "You were logged off because your account is being used elsewhere", type: 'error' });
    }
    
    store.dispatch('AUTH_LOGOUT');
  };
  return Promise.reject(err);
});

axios.interceptors.response.use(
    response => { return response; },
    error => {
      if (
          error.request.responseType === 'blob' &&
          error.response.data instanceof Blob &&
          error.response.data.type &&
          error.response.data.type.toLowerCase().indexOf('json') != -1
      )
      {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            error.response.data = JSON.parse(reader.result);
            resolve(Promise.reject(error));
          };

          reader.onerror = () => {
            reject(error);
          };

          reader.readAsText(error.response.data);
        });
      };

      return Promise.reject(error);
    }
);
